/**
 * Created by Ivan on 08.05.2025
 */

const ScoreBarAvatar = cc.Node.extend({
    ctor: function (player, options) {
        options = this.options = options || {};

        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.createAvatar(player);
        this.createElements(player, options);

        if (options.loading) {
            this.createLoading();
        }

        this.onResize();
        this.setCascadeOpacityEnabledRecursively(true);
    },

    createAvatar: function (player) {
        const styles = cleverapps.styles.ScoreBarAvatar.avatar;

        const avatar = this.avatar = new cleverapps.UI.Avatar(player);
        this.addChild(avatar);
        this.setContentSize(avatar.getContentSize());
        avatar.setAlignment(styles);
    },

    createElements: function (player, options) {
        const styles = cleverapps.styles.ScoreBarAvatar;
        const corner = new cc.Sprite(bundles.score_bar.frames[player.user ? "score_user_corner_png" : "score_opponent_corner_png"]);
        this.avatar.addChild(corner, 2);
        corner.setAlignment(styles.corner);

        if (options.line) {
            const line = this.line = new cc.Sprite(bundles.score_bar.frames.score_avatar_line_png);
            this.addChild(line);
            line.setAlignment(styles.line);
        }
    },

    createLoading: function () {
        const styles = cleverapps.styles.ScoreBarAvatar.loading;

        const avatarBillet = new cc.Sprite(bundles.score_bar.frames.score_avatar_billet_png);
        this.avatar.addChild(avatarBillet);
        avatarBillet.setAlignment(styles.billet);

        const loadingAnimation = new cleverapps.Spine(bundles.score_bar.jsons.loading_json);
        avatarBillet.addChild(loadingAnimation);
        loadingAnimation.setAlignment(styles.animation);
        loadingAnimation.setAnimation(0, "animation", true);

        avatarBillet.runAction(new cc.Sequence(
            new cc.DelayTime(2),
            new cc.CallFunc(() => {
                loadingAnimation.removeFromParent();
            }),
            new cc.FadeOut(0.5),
            new cc.RemoveSelf()
        ));
    },

    onResize: function () {
        const styles = cleverapps.styles.ScoreBarAvatar.avatar;
        this.setScale(styles.scale[cleverapps.resolution.mode]);
    },

    moveAnimation: function (position, silent) {
        this.stopAllActions();

        if (silent) {
            this.setAlignment(position);
            return;
        }

        this.runAction(new cc.MoveTo(0.8, position).easing(cc.easeCubicActionOut()));
    },

    showAnimation: function (position) {
        this.setAlignment(position.x, cleverapps.Scenes.GetRunningScene().height + this.height);
        this.runAction(new cc.Sequence(
            new cc.MoveTo(1, position.x, position.y).easing(cc.easeIn(1)),
            new cc.MoveBy(0.15, 0, 30).easing(cc.easeSineOut()),
            new cc.MoveBy(0.15, 0, -30).easing(cc.easeSineIn())
        ));
    },

    removeAnimation: function () {
        const styles = cleverapps.styles.ScoreBarAvatar.removeAnimation;
        this.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.RotateTo(0.5, 120),
                new cc.MoveBy(0.5, 0, styles.offsetY).easing(cc.easeIn(2)),
                new cc.FadeOut(0.5)
            ),
            new cc.Hide()
        )).setFinalize(() => {
            this.setRotation(0);
            this.setOpacity(255);
        });
    }
});

cleverapps.styles.ScoreBarAvatar = {
    avatar: {
        x: { align: "center" },
        y: { align: "center" },
        scale: [0.4, 0.5, 0.6]
    },

    corner: {
        x: { align: "center" },
        y: { align: "bottom", dy: -29 }
    },

    line: {
        x: { align: "center" },
        y: { align: "bottom", dy: -120 }
    },

    loading: {
        billet: {
            x: { align: "center" },
            y: { align: "center", dy: 3 }
        },

        animation: {
            x: { align: "center" },
            y: { align: "center" }
        }
    },

    removeAnimation: {
        offsetY: -150
    }
};